import React from 'react';
import SyncIcon from 'material-ui/svg-icons/action/autorenew';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import ErrorCheckIcon from '../draftNTemplate-container/error-check-indicator-icon';
import { Dialog, RadioButton, IconMenu, MenuItem, IconButton } from 'material-ui';
import { connect } from 'react-redux';
import {
  syncProductInfo as syncProductInfoAction,
} from '../../../../stores/contracting/dialogs/dialog-constants';
import SameAsCheckbox
  from '../../master-template/btns-switches/sameAs-checkbox';
import R from 'ramda';

const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
const propTypes = {
  justLabel: React.PropTypes.bool,
  labelStyle: React.PropTypes.object,
  labelText: React.PropTypes.string,
  contractId: React.PropTypes.string,
  productId: React.PropTypes.string,
  editable: React.PropTypes.bool,
  showSync: React.PropTypes.bool,
  value: React.PropTypes.oneOf([
    'seasons',
    'offers',
    'extras',
    'blackouts',
    'pickup',
    'dropoff',
    'allocation',
    'checkinout',
    'infant',
    'cancellation',
    'child',
    'family',
    'freeOfCharge',
    'group',
    'marketInfo',
    'termsAndConditions',
    'submissionCriteria',
    'billingInfo',
    'insuranceInfo',
  ]).isRequired,
  syncDataToOtherProducts: React.PropTypes.func,
  children: React.PropTypes.node,
  errors: React.PropTypes.array,
  isADraft: React.PropTypes.bool,
  ratePackageNames: React.PropTypes.array,
  syncProductInfo: React.PropTypes.func,
  onCheckSyncSection: React.PropTypes.func,
  showMasterToggle: React.PropTypes.bool,
  masterTemplateApplied: React.PropTypes.bool,
  openEditDialog: React.PropTypes.func,
  actions: React.PropTypes.array,
};

class HelperLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      loading: false,
      syncRatesToo: false,
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes);
    return (
      !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) ||
      !R.equals(this.state, nextState)
    );
  }
  onConfirm = () => {
    const { productId, value, contractId, syncProductInfo } = this.props;
    const { dialogContentType, syncRatesToo } = this.state;
    if (dialogContentType === 'sync') {
      syncProductInfo({ contractId, productId, sectionInEdit: value, syncRatesToo }).then(() =>
        this.setState({ loading: false, dialogOpen: false }),
      );
    }
  };
  getDialogContent = () => {
    const { value, labelText } = this.props;
    const { syncRatesToo, dialogContentType } = this.state;
    if (dialogContentType === 'sync') {
      if (value === 'seasons') {
        return (
          <div>
            <label>Please select what you would like to sync to other products:</label>
            <RadioButton
              label="Seasons"
              checked={!syncRatesToo}
              onCheck={() => this.setState({ syncRatesToo: false })}
            />
            <RadioButton
              label="Seasons with Rates"
              checked={syncRatesToo}
              onCheck={() => this.setState({ syncRatesToo: true })}
            />
            <br />
            <i>
              Please note that existing {!syncRatesToo ? 'SEASON' : 'SEASON & RATES'} in other
              products will be overwritten.
            </i>
          </div>
        );
      }
      return <i>Please note that existing {labelText} in other products will be overwritten.</i>;
    }

    return <input />;
  };
  openPopover = dialogContentType => () => this.setState({ dialogOpen: true, dialogContentType });
  render() {
    const {
      justLabel,
      contractId,
      value,
      labelStyle,
      children,
      labelText,
      editable,
      showSync,
      showMasterToggle,
      masterTemplateApplied,
      errors,
      actions = [],
    } = this.props;
    const { dialogOpen } = this.state;
    const loading = this.state.loading;
    if (justLabel) {
      return (
        <div
          style={R.merge({ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }, labelStyle)}
        >
          <b>{children || labelText}</b>
        </div>
      );
    }
    return (
      <div className="flex-tc-sb">
        <div
          style={R.merge({ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }, labelStyle)}
        >
          <b>{children || labelText}</b>
          {errors.map((err, index) => (
            <div key={index} style={{ display: 'flex', alignItems: 'center', color: '#f44336' }}>
              &nbsp; <ErrorCheckIcon showError /> &nbsp;
              {err}
            </div>
          ))}
        </div>
        {
          showMasterToggle && (
            <SameAsCheckbox
              editable={editable}
              sectionValue={value}
              templateDraftId={contractId}
              masterTemplateApplied={masterTemplateApplied}
            />
          )
        }
        {editable && (showSync || actions.length > 1) && (
          <IconMenu desktop iconButtonElement={<IconButton iconClassName="tc-icon-more-vert" />}>
            <MenuItem
              disabled={!showSync}
              primaryText="Sync to Other Product"
              desktop
              onTouchTap={this.openPopover('sync')}
            />
            {
              actions.map(obj => (
                <MenuItem
                  key={obj.label}
                  primaryText={obj.label}
                  desktop
                  onTouchTap={obj.onTouchTap}
                />
              ))
            }
          </IconMenu>
        )}
        {showSync && (
          <Dialog
            open={dialogOpen}
            contentStyle={{ width: '450px' }}
            onRequestClose={() => this.setState({ dialogOpen: false })}
            actions={[
              <FlatButton
                label="cancel"
                primary
                disabled={loading}
                onTouchTap={() => this.setState({ dialogOpen: false })}
              />,
              <FlatButton
                label="confirm"
                secondary
                onTouchTap={this.onConfirm}
                loader={loading}
              />,
            ]}
          >
            {this.getDialogContent()}
          </Dialog>
        )}
      </div>
    );
  }
}

HelperLink.propTypes = propTypes;
export default connect(
  ({ contracting }, { value }) => {
    const contract = contracting.contractActivitiesProducts.toJS();
    const leftNav = contract.leftNav;
    const rightContent = contract.rightSideContent;
    const productId = rightContent.productId;
    const ratePackageIndex = rightContent.ratePackageIndex;
    const draftErrors = contract.draftErrors;
    const isADraft = leftNav.contractState === 'draft' || leftNav.contractState === 'publish-ready';
    const masterTemplateApplied = R.contains(value, rightContent.sameAsCorporatePolicyNotes || []);
    const showMasterToggle = Boolean(rightContent.policyNotesTemplateId);
    const errors = [];
    if (isADraft) {
      if (productId && !isNilOrEmpty(draftErrors)) {
        const productError =
          draftErrors.products.find(R.propEq('ratePackageIndex', ratePackageIndex)) || {};

        if (value === 'seasons') {
          if (R.path(['rates', 'seasonsCoveringWholePeriod'], productError) > 0) {
            errors.push('Required');
          }
          if (R.path(['rates', 'overlappedSeasonRates'], productError) < 0) {
            errors.push('Overlapping Dates');
          }
          if (R.path(['rates', 'datesOutside'], productError)) {
            errors.push('-- Your seasons are not within your contract validity period.');
          }
          // if (R.path(['rates', 'emptySeasonDates'], productError))
          // errors.push('-- One or more seasons have missing dates'); // HANDLED
        }
        if (value === 'offers' && R.path(['offers', 'showOffer'], productError)) {
          if (R.path(['offers', 'emptyDates'], productError)) {
            errors.push('-- Missing Dates');
          } // HANDLED
          if (R.path(['offers', 'datesOutside'], productError)) {
            errors.push('-- Dates fall outside of contracting period');
          }
        }
        if (value === 'allocation') {
          if (R.path(['allocation', 'allocationMissing'], productError)) {
            errors.push('Required');
          }
          if (R.path(['allocation', 'incompleteAllocation'], productError)) {
            errors.push('Incomplete');
          }
          if (R.path(['allocation', 'datesOutside'], productError)) {
            errors.push('-- Dates fall outside of contracting period');
          }
        }
        if (value === 'blackouts' && R.path(['blackouts', 'showBlackout'], productError)) {
          if (R.path(['blackouts', 'emptyDates'], productError)) {
            errors.push('-- Missing Dates');
          } // HANDLED
          if (R.path(['blackouts', 'datesOutside'], productError)) {
            errors.push('-- Dates fall outside of contracting period');
          }
        }
        if (value === 'pickup') {
          if (R.path(['pickup', 'pickupMissing'], productError)) {
            errors.push('Required');
          }
          if (R.path(['pickup', 'incompletePickup'], productError)) {
            errors.push('Incomplete');
          }
          if (R.path(['pickup', 'datesOutside'], productError)) {
            errors.push('-- Dates fall outside of contracting period');
          }
        }
        if (value === 'dropoff') {
          if (R.path(['dropoff', 'dropoffMissing'], productError)) {
            errors.push('Required');
          }
          if (R.path(['dropoff', 'incompleteDropoff'], productError)) {
            errors.push('Incomplete');
          }
          if (R.path(['dropoff', 'datesOutside'], productError)) {
            errors.push('-- Dates fall outside of contracting period');
          }
        }
        if (
          value === 'cancellation' &&
          R.path(['cancellation', 'showCancellation'], productError)
        ) {
          if (R.path(['cancellation', 'incompleteCancellation'], productError)) {
            errors.push('Incomplete');
          }
          if (R.path(['cancellation', 'datesOutside'], productError)) {
            errors.push('-- Dates fall outside of contracting period');
          }
        }
      } else {
        if (value === 'checkinout' && R.propOr([], 'checkInCheckOutMissing', draftErrors).length) {
          errors.push('Required');
        }
        if (value === 'cancellation') {
          if (R.contains('cancellation', draftErrors.policyMissing || [])) {
            errors.push('Required');
          }
          if (draftErrors.incompleteCancellation) {
            errors.push('Incomplete');
          }
        }
        if (value === 'child' && R.contains('child', draftErrors.policyMissing || [])) {
          errors.push('Required');
        }
        // if (value === 'infant' && R.contains('infant', draftErrors.policyMissing))
        // errors.push('Required');
      }
    }
    return {
      productId,
      ratePackageNames: rightContent.ratePackageNames,
      contractId: leftNav.contractId,
      isADraft,
      editable: contracting
        .contractActivitiesProducts
        .getIn(['leftNav', 'supplierEditable']),
      errors,
      showMasterToggle,
      masterTemplateApplied,
    };
  },
  { syncProductInfo: syncProductInfoAction },
)(HelperLink);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/product/helper-link.jsx